import { adminNavItems } from '../admin/adminNav';

function AccountSettings({ user }) {
  const memberSince = user.createdAt
    ? new Date(user.createdAt).toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : 'Not available';

  const spApiExpiry = user.spApiExpiresAt
    ? new Date(user.spApiExpiresAt).toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : 'Not set';

  const isStaff = user.role === 'workspace_user';
  const assignedModules = Array.isArray(user.modules) ? user.modules : [];
  const assignedLabels = assignedModules
    .map((id) => adminNavItems.find((item) => item.id === id)?.label || id)
    .filter(Boolean);

  return (
    <div className="crm-panel">
      <div className="border-b border-[rgb(var(--crm-border))] px-5 py-4">
        <h4 className="text-base font-semibold">Profile</h4>
        <p className="crm-text-muted mt-1 text-sm">Information tied to your login.</p>
      </div>
      <dl className="grid gap-4 px-5 py-5 sm:grid-cols-2">
        <div className="grid gap-1">
          <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">Full name</dt>
          <dd className="font-medium">{user.name || 'Not provided'}</dd>
        </div>
        <div className="grid gap-1">
          <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">Email</dt>
          <dd className="font-medium">{user.email}</dd>
        </div>
        <div className="grid gap-1">
          <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">Phone</dt>
          <dd className="font-medium">{user.phone || 'Not provided'}</dd>
        </div>
        <div className="grid gap-1">
          <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">Role</dt>
          <dd className="font-medium">{user.roleLabel || user.role}</dd>
        </div>
        <div className="grid gap-1">
          <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">Member since</dt>
          <dd className="font-medium">{memberSince}</dd>
        </div>
        {user.role === 'admin' ? (
          <>
            <div className="grid gap-1">
              <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">
                SP-API status
              </dt>
              <dd className="font-medium">
                {user.hasSpApiConfigured ? 'Connected' : 'Not configured'}
              </dd>
            </div>
            <div className="grid gap-1">
              <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">
                SP-API expires
              </dt>
              <dd className="font-medium">{spApiExpiry}</dd>
            </div>
          </>
        ) : null}
        {isStaff ? (
          <div className="grid gap-1 sm:col-span-2">
            <dt className="crm-text-muted text-xs font-semibold uppercase tracking-wide">
              Assigned sections
            </dt>
            <dd className="font-medium">
              {assignedLabels.length ? assignedLabels.join(' · ') : 'None assigned'}
            </dd>
          </div>
        ) : null}
      </dl>
    </div>
  );
}

export default AccountSettings;
